require("./gallery");

import "@/gallery/widget.scss";
